var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-navigator"},[_c('b-navbar-nav',{staticClass:"nav menu-navigator"},[_c('HeaderDropdown'),_c('HeaderFranqueada')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }